import { ICommand } from 'core-ts-types';
import { IDelegateResponder, IDelegateConstant, IDelegateController } from 'ui-ng-delegate';

export type Validation = Record<string, boolean>;

export class PhxPasswordValidationPopoverController {
  constructor(private validatePasswordCommand: ICommand) {}
  hasFailingValidation(validations: any): boolean {
    // When there are no failing validations, all keys will be true
    if (typeof validations === 'undefined') {
      return false;
    }
    const validationStatuses = _.values(validations);
    const failingValidation = validationStatuses.some((validationResult: any) => !validationResult);
    return failingValidation;
  }

  isPasswordRequiredOrNonEmpty(password: string, passwordRequired: boolean): boolean {
    return passwordRequired || !_.isEmpty(password);
  }
}

class PhxPasswordValidationPopoverDelegate {
  constructor(DelegateController: IDelegateController, phxPasswordValidationPopoverConfiguration: IDelegateConstant) {
    DelegateController(this, phxPasswordValidationPopoverConfiguration);
  }
}

angular
  .module('capability-ng-user-app')
  .service('phxPasswordValidationPopoverDelegate', PhxPasswordValidationPopoverDelegate)
  .constant('phxPasswordValidationPopoverConfiguration', {
    uniqueComponent: 'phxPasswordValidationPopover',
    vocabulary: {
      showPopover: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        element.css('display', 'block');
        element.children('.validation-popover').css('display', 'block');
        element.children('.validation-error-box').css('display', 'none');
      },
      showErrorBox: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        element.css('display', 'block');
        element.children('.validation-popover').css('display', 'none');
        element.children('.validation-error-box').css('display', 'block');
      },
      hidePopover: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        element.children('.validation-popover').css('display', 'none');
      },
      hideBoth: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        element.children('.validation-popover').css('display', 'none');
        element.children('.validation-error-box').css('display', 'none');
      },
      toggle: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        // DEBT manage a value on scope or controller and control visibility with display classes in ui-sass-typography
        element.css('display', 'block');
        element.children('.validation-popover').css('display') === 'block'
          ? element.css('display', 'none')
          : element.css('display', 'block');
      }
    }
  })
  .controller('ngPhxPasswordValidationPopoverController', PhxPasswordValidationPopoverController)
  .directive(
    'phxPasswordValidationPopover',
    (DelegateResponder: any, phxPasswordValidationPopoverConfiguration: any) => {
      return {
        controller: 'ngPhxPasswordValidationPopoverController',
        controllerAs: '$ctrl',
        templateUrl: 'lib/user_app/components/password_validation_popover/password_validation_popover.html',
        scope: {
          ngModel: '<',
          passwordRequired: '<',
          password: '<'
        },
        link: DelegateResponder(
          phxPasswordValidationPopoverConfiguration,
          (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {}
        )
      };
    }
  );



// WEBPACK FOOTER //
// ./app/lib/user_app/components/password_validation_popover/password_validation_popover.ts